import React from 'react'

export default function SMSGroup() {
  return (
    <div>
      <h1>sms Group</h1>
    </div>
  )
}
